import { FaroSimpleTextField } from "@components/common/faro-text-field/faro-simple-text-field";
import { Text } from "@flat-ui";
import { Autocomplete, ListItem } from "@mui/material";
import { IntegrationAutocompleteItem } from "@pages/project-details/project-integrations/integration-autocomplete-item";
import { IntegrationEntityBase } from "@services/integrations-service/integrations-service-types";

interface Props<T> {
  /** Selected value */
  value: T | null;

  /** List of integration entry to show as autocomplete item */
  options: T[];

  /** Text to display when there are no options available */
  noOptionsText: string;

  /** Callback function to update selected item */
  onChange(value: T | null): void;

  /** Placeholder text to show in autocomplete input autocomplete */
  placeholder: string;

  /** Flag to disable the autocomplete */
  shouldDisabled?: boolean;

  /** Flag to focus the autocomplete */
  shouldFocus?: boolean;
}

/** Renders autocomplete for integration entry */
export function IntegrationAutocomplete<T extends IntegrationEntityBase>({
  value,
  options,
  noOptionsText,
  onChange,
  shouldDisabled = false,
  shouldFocus = false,
  placeholder,
}: Props<T>): JSX.Element {
  return (
    <Autocomplete
      value={value}
      disabled={shouldDisabled}
      options={options}
      getOptionLabel={(option) => option.name}
      noOptionsText={<Text variant="bodyM">{noOptionsText}</Text>}
      filterSelectedOptions
      onChange={(_, value) => onChange(value)}
      renderInput={(params) => (
        <FaroSimpleTextField
          {...params}
          autoFocus={shouldFocus}
          variant="outlined"
          placeholder={placeholder}
          sx={{
            "& .MuiOutlinedInput-root": { paddingY: "2px" },
          }}
        />
      )}
      renderOption={(props, option, state) => {
        return (
          <ListItem
            {...props}
            sx={{ padding: "0" }}
            key={`listItem-${state.index}`}
          >
            <IntegrationAutocompleteItem
              title={option.name}
              inputValue={state.inputValue}
            />
          </ListItem>
        );
      }}
    />
  );
}
